import { EasyAvatar } from "fin-web-components";
import { avatarDisplayWord } from "../../../utils/avatarDisplayWord";
import type { SpaceProfile } from "../SpaceType";

export function SpaceModuleSubscribedSoon(props: {
  spaceProfile: SpaceProfile | null;
}): JSX.Element {
  const { spaceProfile } = props;
  const spaceName = spaceProfile?.name?.trim() ?? "";
  const spaceAvatar = spaceProfile?.avatarUrl?.trim() ?? "";
  const showHost = spaceName !== "" || spaceAvatar !== "";
  return (
    <div className="space-access-soon" aria-label="已开通提示">
      <div className="space-access-soon__inner">
        {showHost ? (
          <div className="space-access-soon__host">
            <EasyAvatar
              shape="square"
              squareRadius={0}
              size={40}
              url={spaceAvatar !== "" ? spaceAvatar : undefined}
              word={avatarDisplayWord(spaceName || "本空间")}
              alt=""
              className="space-access-soon__host-avatar"
            />
            <div className="space-access-soon__host-lines">
              <span className="space-access-soon__host-name">
                {spaceName !== "" ? spaceName : "本空间"}
              </span>
              <span className="space-access-soon__host-note">
                你已具备访问本模块的权益
              </span>
            </div>
          </div>
        ) : null}
        <p className="space-access-soon__headline">内容正在接入</p>
        <p className="space-access-soon__body">
          业务内容接入完成后将直接展示在此。请先前往空间首页查看动态与通知。
        </p>
      </div>
    </div>
  );
}
